import { initWidget } from './widget';
import endpoints from './widget/define/endpoints';

import WishList from './widget/component/WishList';

const initWishListPageWidgets = () => {
    const props = {
        endpoints,
    };

    initWidget('wish-list', WishList, props);
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWishListPageWidgets.bind(this));
} else {
    initWishListPageWidgets();
}